"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prefetchMode = false;
// Use prefetch() to run a section of code under prefetch mode.  Service calls
// made under prefetch mode are issued with a lower priority so as not to
// interfere with requests that need to return immediately.
//
// Example usage:
//
// prefetch(() => {
//     makeSomeServiceRequest();
// });
//
function prefetch(callback) {
    if (prefetchMode) {
        throw new Error("Calls to prefetch() may not be nested.");
    }
    try {
        prefetchMode = true;
        callback();
    }
    finally {
        prefetchMode = false;
    }
}
exports.default = prefetch;
function isInPrefetchMode() {
    return prefetchMode;
}
exports.isInPrefetchMode = isInPrefetchMode;
